/* POWMIX wow: plan de geles gel a gel (race-plan y calculadora) y botón "Añadir mi kit".
   Sin librerías. Las secciones lo cargan con defer; si se carga dos veces, la segunda no hace nada.
   El kit se añade con un formulario oculto a /cart/add: assets/cart-drawer.js lo intercepta, hace el
   fetch a /cart/add.js y abre el carrito lateral. Sin carrito lateral, Shopify lleva al carrito. */
(function () {
  if (window.PMWow) return;
  var W = (window.PMWow = {});
  var SVGNS = 'http://www.w3.org/2000/svg';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function once(el, k) { k = '__pmw' + k; if (el[k]) return false; el[k] = 1; return true; }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function svg(tag, attrs) {
    var n = document.createElementNS(SVGNS, tag);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    return n;
  }
  function fmtNum(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  W.fmtDur = function (min) {
    var h = Math.floor(min / 60), m = Math.round(min % 60);
    if (!h) return m + ' min';
    return h + ' h' + (m ? ' ' + (m < 10 ? '0' : '') + m : '');
  };
  W.flavorKey = function (name) {
    var h = (name || '').toLowerCase();
    if (/berr|banana|frutos/.test(h)) return 'berries';
    if (/mango|passion|caff/.test(h)) return 'mango';
    if (/tropical|pi[nñ]a|lima/.test(h)) return 'tropical';
    return 'mix';
  };

  /* Criterio único de hitos (race-plan y calculadora):
     - un gel cada (g por gel / pauta) horas, desde ese mismo minuto: 60 g/h = cada 30 min desde el 30;
     - ninguno en los últimos 5 minutos;
     - los del último tercio, el sabor con cafeína (máximo caffMax);
     - el resto alterna los dos sabores sin cafeína; el tercero va destacado. */
  W.plan = function (minutes, rate, o) {
    o = o || {};
    var g = o.gelG || 30;
    var caffMax = o.caffMax == null || isNaN(o.caffMax) ? 2 : o.caffMax;
    minutes = Math.max(0, +minutes || 0);
    rate = +rate || 60;
    var step = Math.max(15, Math.round((60 * g) / rate / 5) * 5);
    var times = [];
    for (var t = step; t <= minutes - 5; t += step) times.push(t);
    if (!times.length && minutes >= 45) times.push(Math.round(minutes / 2 / 5) * 5);
    var lastThird = (minutes * 2) / 3, caffUsed = 0, alt = 0;
    return times.map(function (t, i) {
      var caff = !!o.flavorCaff && t >= lastThird && caffUsed < caffMax;
      var flavor;
      if (caff) { caffUsed++; flavor = o.flavorCaff; } else { flavor = alt++ % 2 ? o.flavorB : o.flavorA; }
      return { n: i + 1, t: t, frac: minutes ? t / minutes : 0, flavor: flavor || '', key: W.flavorKey(flavor), caff: caff, third: i === 2 };
    });
  };

  /* Variante que cubre n geles: sabor del kit (o Mix, o el primero), la cantidad más pequeña que llega;
     si ninguna llega, varias unidades de la mayor. */
  W.pickKit = function (data, n, kitFlavor) {
    var vs = ((data && data.variants) || []).filter(function (v) { return v.available; });
    if (!vs.length || n < 1) return null;
    var want = (kitFlavor || '').toLowerCase().trim();
    var pool = want ? vs.filter(function (v) { return (v.flavor || '').toLowerCase().trim() === want; }) : [];
    if (!pool.length) pool = vs.filter(function (v) { return /mix/i.test(v.flavor || ''); });
    if (!pool.length) { var f0 = vs[0].flavor; pool = vs.filter(function (v) { return v.flavor === f0; }); }
    pool.sort(function (a, b) { return a.qty - b.qty; });
    for (var i = 0; i < pool.length; i++) if (pool[i].qty >= n) return { v: pool[i], units: 1 };
    var big = pool[pool.length - 1];
    return { v: big, units: Math.ceil(n / Math.max(1, big.qty)) };
  };

  W.addKit = function (id, units, host) {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var f = document.createElement('form');
    f.method = 'post';
    f.action = root + 'cart/add';
    f.hidden = true;
    f.innerHTML = '<input type="hidden" name="id"><input type="hidden" name="quantity"><button type="submit" tabindex="-1"></button>';
    f.elements.id.value = id;
    f.elements.quantity.value = units || 1;
    (host || document.body).appendChild(f);
    if (f.requestSubmit) f.requestSubmit(); else f.submit();
    setTimeout(function () { if (f.parentNode) f.parentNode.removeChild(f); }, 10000);
  };

  function kitBinder(root, btn, label, kitFlavor) {
    var data = null, current = null;
    var s = $('[data-plan-variants]', root);
    try { data = s ? JSON.parse(s.textContent) : null; } catch (e) { data = null; }
    if (btn) {
      btn.addEventListener('click', function (e) {
        if (!current) return;
        e.preventDefault();
        W.addKit(current.v.id, current.units, root);
      });
    }
    return {
      update: function (n) {
        current = W.pickKit(data, n, kitFlavor);
        if (!label) return;
        if (!current) { label.textContent = ''; return; }
        var v = current.v;
        label.textContent = (v.flavor ? v.flavor + ' · ' : '') + (current.units > 1 ? current.units + ' × ' : '') + v.qty + ' geles' + (current.units === 1 && v.price ? ' · ' + v.price : '');
      }
    };
  }

  function bump(node, text) {
    if (!node || node.textContent === String(text)) return;
    node.textContent = text;
    if (reduce) return;
    node.classList.remove('is-bump');
    void node.offsetWidth;
    node.classList.add('is-bump');
  }

  function planOpts(d) {
    return {
      gelG: parseFloat(d.gelG) || 30,
      caffMax: d.caffMax === '' || d.caffMax == null ? 2 : parseInt(d.caffMax, 10),
      flavorA: d.flavorA || 'Red Berries Banana',
      flavorB: d.flavorB || 'Tropical',
      flavorCaff: d.flavorCaff || 'Mango Passion CAFF'
    };
  }

  /* ---------- race-plan ---------- */
  function initRace(root) {
    if (!once(root, 'rp')) return;
    var d = root.dataset, opts = planOpts(d);
    var gelNa = parseFloat(d.gelNa) || 300;
    var tabs = $$('[data-rp-tab]', root);
    var stage = $('[data-rp-stage]', root), track = $('[data-rp-track]', root), list = $('[data-rp-list]', root);
    if (!tabs.length || !stage || !track || !list) return;
    var mqH = window.matchMedia('(min-width: 750px)');
    var kit = kitBinder(root, $('[data-kit-add]', root), $('[data-kit-label]', root), d.kitFlavor);
    var st = { plan: [], minutes: 0, len: 0, path: null, done: null, runner: null, dots: [], fracs: [], items: [], p: -1 };
    var live = !reduce;
    root.classList.toggle('is-live', live);

    function buildList() {
      list.textContent = '';
      st.items = st.plan.map(function (g) {
        var li = el('li', 'pm-rp__gel pm-rp__gel--' + g.key + (g.third ? ' is-third' : '') + (g.caff ? ' is-caff' : ''));
        var min = el('span', 'pm-rp__min');
        min.appendChild(el('small', null, d.txtMin || 'Min'));
        min.appendChild(el('b', null, g.t));
        li.appendChild(min);
        var body = el('div', 'pm-rp__body');
        body.appendChild(el('span', 'pm-rp__n', (d.txtGel || 'Gel') + ' ' + g.n + ' · ' + W.fmtDur(g.t)));
        var fl = el('span', 'pm-rp__flavor');
        fl.appendChild(el('i', 'pm-dot pm-dot--' + g.key));
        fl.appendChild(document.createTextNode(g.flavor));
        body.appendChild(fl);
        body.appendChild(el('span', 'pm-rp__note', g.caff ? d.txtCaff : d.txtNote));
        if (g.third && d.txtThird) {
          body.appendChild(el('strong', 'pm-rp__third', d.txtThird));
          if (d.txtThirdSub) body.appendChild(el('span', 'pm-rp__thirdsub', d.txtThirdSub));
        }
        li.appendChild(body);
        list.appendChild(li);
        return li;
      });
    }

    function buildTrack() {
      track.textContent = '';
      st.dots = []; st.fracs = [];
      var horiz = mqH.matches, w, h, pts = [], i;
      if (horiz) {
        w = 1000; h = 150;
        for (i = 0; i <= 96; i++) {
          var x = 20 + i * 10;
          var k = (x - 20) / 960;
          pts.push([x, 92 + 26 * Math.sin(k * Math.PI * 3.1 + 0.5) + 8 * Math.sin(k * Math.PI * 11)]);
        }
        track.style.top = ''; track.style.height = '';
      } else {
        w = 56; h = Math.max(200, list.offsetHeight);
        for (i = 0; i <= Math.ceil(h / 12); i++) {
          var y = Math.min(h, i * 12);
          pts.push([28 + 11 * Math.sin(y / 130), y]);
        }
        track.style.top = list.offsetTop + 'px';
        track.style.height = h + 'px';
      }
      var dd = 'M' + pts.map(function (p) { return p[0].toFixed(1) + ' ' + p[1].toFixed(1); }).join(' L');
      var s = svg('svg', { viewBox: '0 0 ' + w + ' ' + h, class: 'pm-rp__svg', focusable: 'false' });
      if (horiz) s.setAttribute('preserveAspectRatio', 'xMidYMid meet');
      s.appendChild(svg('path', { d: dd, class: 'pm-rp__route' }));
      var done = svg('path', { d: dd, class: 'pm-rp__done' });
      s.appendChild(done);
      track.appendChild(s);
      var L = done.getTotalLength();
      st.len = L; st.path = done; st.done = done;
      done.style.strokeDasharray = L + ' ' + L;
      done.style.strokeDashoffset = live ? L : 0;

      /* tabla longitud -> coordenada para colocar los hitos */
      var N = 300, table = [];
      for (i = 0; i <= N; i++) { var pt = done.getPointAtLength((L * i) / N); table.push(horiz ? pt.x : pt.y); }
      function lenAt(c) {
        var lo = 0, hi = N;
        while (lo < hi) { var mid = (lo + hi) >> 1; if (table[mid] < c) lo = mid + 1; else hi = mid; }
        return (L * lo) / N;
      }
      var g = svg('g', { class: 'pm-rp__dots' });
      st.plan.forEach(function (gel, idx) {
        var c;
        if (horiz) c = 20 + gel.frac * 960;
        else { var li = st.items[idx]; c = li.offsetTop + Math.min(34, li.offsetHeight / 2); }
        var len = lenAt(c), p = done.getPointAtLength(len);
        st.fracs.push(L ? len / L : 0);
        var dot = svg('g', { class: 'pm-rp__dot pm-rp__dot--' + gel.key + (gel.third ? ' is-third' : ''), transform: 'translate(' + p.x.toFixed(1) + ' ' + p.y.toFixed(1) + ')' });
        if (gel.third) dot.appendChild(svg('circle', { r: 13, class: 'pm-rp__halo' }));
        dot.appendChild(svg('circle', { r: horiz ? 8 : 7, class: 'pm-rp__pin' }));
        if (horiz) {
          var tx = svg('text', { y: -18, 'text-anchor': 'middle' });
          tx.textContent = gel.t + "'";
          dot.appendChild(tx);
        }
        g.appendChild(dot);
        st.dots.push(dot);
      });
      s.appendChild(g);
      var r = svg('g', { class: 'pm-rp__runner' });
      r.appendChild(svg('circle', { r: 17, class: 'pm-rp__runbg' }));
      r.appendChild(svg('circle', { cx: 2.5, cy: -8.5, r: 2.6, class: 'pm-rp__runhead' }));
      r.appendChild(svg('path', { d: 'M1 -4.5 L-1.5 2.5 L3.5 6 L2 11.5 M-1.5 2.5 L-6.5 7.5 M0.5 -3.5 L6 -0.5 M0.5 -3.5 L-5 -1.5', class: 'pm-rp__body-line' }));
      s.appendChild(r);
      st.runner = r;
      st.p = -1;
      apply(live ? progress() : 1);
    }

    function progress() {
      var r = stage.getBoundingClientRect(), vh = window.innerHeight || 800;
      var p = (vh * 0.85 - r.top) / (vh * 0.3 + r.height);
      return Math.min(1, Math.max(0, p));
    }

    function apply(p) {
      if (!st.len || Math.abs(p - st.p) < 0.0005) return;
      st.p = p;
      st.done.style.strokeDashoffset = st.len * (1 - p);
      var pt = st.path.getPointAtLength(st.len * p);
      st.runner.setAttribute('transform', 'translate(' + pt.x.toFixed(1) + ' ' + pt.y.toFixed(1) + ')');
      for (var i = 0; i < st.fracs.length; i++) {
        var on = p >= st.fracs[i] - 0.004;
        st.dots[i].classList.toggle('is-on', on);
        if (st.items[i]) st.items[i].classList.toggle('is-on', on);
      }
      root.classList.toggle('is-finished', p >= 0.995);
    }

    function render(tab) {
      st.minutes = parseFloat(tab.getAttribute('data-minutes')) || 0;
      st.plan = W.plan(st.minutes, parseFloat(tab.getAttribute('data-rate')) || 60, opts);
      var t = $('[data-rp-time]', root);
      if (t) t.textContent = tab.getAttribute('data-time') || W.fmtDur(st.minutes);
      buildList();
      buildTrack();
      var n = st.plan.length;
      bump($('[data-rp-gels]', root), n);
      bump($('[data-rp-carbs]', root), fmtNum(Math.round(n * opts.gelG)));
      bump($('[data-rp-sodium]', root), fmtNum(Math.round(n * gelNa)));
      kit.update(n);
    }

    function select(tab, focus) {
      tabs.forEach(function (b) {
        var on = b === tab;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.tabIndex = on ? 0 : -1;
        b.classList.toggle('is-selected', on);
      });
      stage.setAttribute('aria-labelledby', tab.id);
      if (focus) tab.focus();
      render(tab);
    }

    tabs.forEach(function (b, i) {
      b.addEventListener('click', function () { select(b); });
      b.addEventListener('keydown', function (e) {
        var j = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = tabs.length - 1;
        if (j === null) return;
        e.preventDefault();
        select(tabs[j], true);
      });
    });
    root.addEventListener('shopify:block:select', function (e) {
      var b = e.target.closest && e.target.closest('[data-rp-tab]');
      if (b) select(b);
    });

    /* scroll: solo se escucha mientras la sección está cerca de la pantalla */
    var ticking = false, near = false;
    function onScroll() {
      if (ticking || !near) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; apply(progress()); });
    }
    if (live) {
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          near = en[0].isIntersecting;
          if (near) onScroll();
        }, { rootMargin: '25% 0px 25% 0px' }).observe(stage);
      } else { near = true; }
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    var rebuildPending = false;
    function rebuild() {
      if (rebuildPending) return;
      rebuildPending = true;
      window.requestAnimationFrame(function () { rebuildPending = false; buildTrack(); });
    }
    if (mqH.addEventListener) mqH.addEventListener('change', rebuild); else if (mqH.addListener) mqH.addListener(rebuild);
    var lastW = window.innerWidth;
    window.addEventListener('resize', function () { if (window.innerWidth !== lastW) { lastW = window.innerWidth; rebuild(); } });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(rebuild);

    var first = tabs.filter(function (b) { return b.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];
    select(first);
  }

  /* ---------- calculadora ---------- */
  function initCalc(root) {
    if (!once(root, 'calc')) return;
    var d = root.dataset, opts = planOpts(d);
    var gelNa = parseFloat(d.gelNa) || 300;
    var hours = $('[data-calc-hours]', root);
    if (!hours) return;
    var hoursOut = $('[data-calc-hours-out]', root);
    var gelsEl = $('[data-calc-gels]', root);
    var sub = $('[data-calc-sub]', root);
    var tl = $('[data-calc-tl]', root);
    var note = $('[data-calc-note]', root), tags = $('[data-calc-tags]', root);
    var packs = (d.packs || '3,12,24,36').split(',').map(function (x) { return parseInt(x, 10); }).filter(function (x) { return x > 0; }).sort(function (a, b) { return a - b; });
    var kit = kitBinder(root, $('[data-kit-add]', root), $('[data-kit-label]', root), d.kitFlavor);
    var fmt = function (n) { return String(n).replace('.', ','); };

    function timeline(plan, minutes) {
      if (!tl) return;
      tl.textContent = '';
      var bar = el('div', 'pm-tl__bar');
      bar.appendChild(el('span', 'pm-tl__fill'));
      plan.forEach(function (g) {
        var dot = el('i', 'pm-tl__dot pm-dot pm-dot--' + g.key + (g.third ? ' is-third' : ''));
        dot.style.left = (g.frac * 100).toFixed(2) + '%';
        bar.appendChild(dot);
      });
      tl.appendChild(bar);
      var ends = el('div', 'pm-tl__ends');
      ends.appendChild(el('span', null, d.txtStart || 'Salida'));
      ends.appendChild(el('span', null, (d.txtFinish || 'Meta') + ' · ' + W.fmtDur(minutes)));
      tl.appendChild(ends);
      var ol = el('ol', 'pm-tl__list');
      plan.forEach(function (g) {
        var li = el('li', 'pm-tl__item' + (g.third ? ' is-third' : ''));
        li.appendChild(el('b', null, (d.txtMin || 'Min') + ' ' + g.t));
        var f = el('span', 'pm-tl__flavor');
        f.appendChild(el('i', 'pm-dot pm-dot--' + g.key));
        f.appendChild(document.createTextNode(g.flavor));
        li.appendChild(f);
        ol.appendChild(li);
      });
      tl.appendChild(ol);
      if (plan.length >= 3 && d.txtThird) tl.appendChild(el('p', 'pm-tl__third', d.txtThird));
      if (!reduce) {
        tl.classList.remove('is-in');
        void tl.offsetWidth;
        tl.classList.add('is-in');
      }
    }

    function update() {
      var h = parseFloat(hours.value) || 0;
      var minutes = Math.round(h * 60);
      var checked = $('[data-calc-rate]:checked', root);
      var rate = checked ? parseFloat(checked.value) : 60;
      var plan = W.plan(minutes, rate, opts);
      var n = plan.length;
      if (hoursOut) hoursOut.textContent = fmt(h) + ' h';
      bump(gelsEl, n);
      var pack = packs.filter(function (p) { return p >= n; })[0];
      if (sub) sub.textContent = pack ? (d.txtPack || '').replace('[pack]', pack) : d.txtBig || '';
      timeline(plan, minutes);
      kit.update(n);
      if (note) {
        note.value = 'Plan POWMIX: ' + W.fmtDur(minutes) + ' a ' + rate + ' g/h. ' + n + ' geles (' + n * opts.gelG + ' g de carbohidratos, ' + n * gelNa + ' mg de sodio). ' +
          plan.map(function (g) { return 'min ' + g.t + ' ' + g.flavor; }).join('; ') + '.';
      }
      if (tags) tags.value = (tags.getAttribute('data-base') || 'plan-carrera,calculadora') + ',plan-' + n + '-geles';
    }
    hours.addEventListener('input', update);
    $$('[data-calc-rate]', root).forEach(function (r) { r.addEventListener('change', update); });
    update();
  }

  function init(scope) {
    $$('[data-rp]', scope).forEach(initRace);
    $$('[data-calc]', scope).forEach(initCalc);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
